import { Fragment, useState } from "react";
import { Button } from "react-bootstrap";

const WeekHeader = ({
  calendarRef,
  addEvent,
  handleCalendarChange,
  formatDate,
}) => {
  let calendarApi = calendarRef.current.getApi();
  const [title, setTitle] = useState(calendarApi.view.title);
  const getStartEndDate = () => {
    const start_date = formatDate(calendarApi.view.activeStart);
    const end_date = formatDate(calendarApi.view.activeEnd);
    return { start_date, end_date };
  };

  const refreshCalendar = () => {
    handleCalendarChange(getStartEndDate());
    calendarApi.render();
  };
  const nextHandle = () => {
    calendarApi.next();
    handleCalendarChange(getStartEndDate());
    setTitle(calendarApi.view.title);
  };
  const prevHandle = () => {
    calendarApi.prev();
    handleCalendarChange(getStartEndDate());
    setTitle(calendarApi.view.title);
  };
  return (
    <Fragment>
      <h2>Agenda Semanal</h2>
      <div className="calendar-app-header row">
        <div className="col title"></div>
        <div className="col date-title">
          <Button variant="outline-primary" onClick={prevHandle}>
            <i className="bi bi-arrow-left"></i>
          </Button>
          <h2>{title}</h2>
          <Button variant="outline-primary" onClick={nextHandle}>
            <i className="bi bi-arrow-right"></i>
          </Button>
        </div>
        <div className="col justify-content-end add-event-btn gap-2">
          <Button variant="outline-secondary" onClick={refreshCalendar}>
            Refrescar <i className="bi bi-arrow-clockwise" />
          </Button>
          <Button variant="primary" onClick={() => addEvent()}>
            Agregar Cita
            <i className="bi bi-calendar2-plus ms-2"></i>
          </Button>
        </div>
      </div>
    </Fragment>
  );
};

export default WeekHeader;
